import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import {
  CommentOutlined,
  GlobalOutlined,
  ShoppingCartOutlined,
  SkinOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import PermissionTabsLayout, {
  PermissionTabsRedirect,
} from "../components/PermissionTabsLayout.jsx";
import useIsMobile from "../hooks/useIsMobile";

const ECOMMERCE_TABS = [
  {
    key: "commandes-en-ligne",
    label: "Commandes en ligne",
    icon: <ShoppingCartOutlined />,
    path: "/gestion-ecommerce/commandes-en-ligne",
    permission: "Gestion Commerciale.Ecommerce.CommandesEnLigne.view",
  },
  {
    key: "avis-clients",
    label: "Gestion des avis",
    icon: <CommentOutlined />,
    path: "/gestion-ecommerce/avis-clients",
    permission: "Gestion Commerciale.Ecommerce.CommandesEnLigne.view",
  },
  {
    key: "fiches-produit",
    label: "Fiches produit",
    icon: <SkinOutlined />,
    path: "/gestion-ecommerce/fiches-produit",
    permission: "Gestion Commerciale.Ecommerce.Configuration.FichesProduit.view",
  },
  {
    key: "configuration-boutique",
    label: "Configuration boutique",
    icon: <GlobalOutlined />,
    path: "/gestion-ecommerce/configuration-boutique",
    permission: "Gestion Commerciale.Ecommerce.Configuration.Boutiques.view",
  },
  {
    key: "parametres-frontend",
    label: "Parametres frontend",
    icon: <ToolOutlined />,
    path: "/gestion-ecommerce/parametres-frontend",
    permission: "Gestion Commerciale.Ecommerce.Configuration.Frontend.view",
  },
];

export const EcommerceTabsRedirect = () => (
  <PermissionTabsRedirect tabs={ECOMMERCE_TABS} />
);

const EcommerceTabsLayout = () => {
  const isMobile = useIsMobile();
  const parentOutletContext = useOutletContext();
  if (isMobile) return <Outlet context={parentOutletContext} />;
  return <PermissionTabsLayout tabs={ECOMMERCE_TABS} />;
};

export default EcommerceTabsLayout;
